import React from 'react';
import './Index.css';
import HomeIamge from '../../Assets/Photos/SignUp.svg';
const StaticContainer = ({ children }) => {
    return (
        <div className="static-container">
            <div className="static-container-left">{children}</div>
            <div className="static-container-right">
                <div className="container_img">
                    <img src={HomeIamge} alt="Home" className="container_img_img" />
                    <div>
                        <h2>Lorem Epsum</h2>
                        <p>
                            Show your customers how would a design look on phone cases, t-shirts and other products, on
                            the panel.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaticContainer;
